// Terms.jsx
export default function Terms() {
    return (
        <div className="space-y-4">
            <h1 className="text-4xl font-semibold">Terms of Use</h1>
            <p className="mb-2">
                By using this website, you agree to use it for personal, non-commercial purposes only.
            </p>
            <p className="mb-2">
                All content is provided "as is" without warranties of any kind. The website owner is not responsible for any
                issues arising from use.
            </p>
            <p className="mb-2">
                This site is provided free of charge and does not require registration.
            </p>
            <p>Use the site at your own discretion.</p>
        </div>
    );
}
